import React, { useState } from 'react';
import { FaInfoCircle, FaTrash } from 'react-icons/fa';
import { Button, Input, Table } from 'reactstrap';
import { ProductContainer } from './styled';
import Select from 'react-select';
import { getFlexSelectCustomStyle } from 'assets/styles/multiple_select';
import ProductDetailsModal from './ProductDetailsModal';

export const SelectedProductsTable = ({
  products = [],
  setProducts = () => {},
  selectedProducts = new Set(),
  setSelectedProducts = () => {},
  productsList = [],
  control
}) => {
  const [modal, setModal] = useState(false);
  const [productIdSelectedModal, setProductIdSelectedModal] = useState(null);
  const toggleModal = () => setModal(!modal);

  const handleInfoClick = (productId) => {
    setProductIdSelectedModal(productId);
    toggleModal();
  };

  const getAvailableProducts = () => {
    return productsList.filter((product) => !selectedProducts.has(product.id));
  };

  const handleAddProduct = () => {
    setProducts([
      ...products,
      {
        id: Date.now(),
        productId: null,
        name: '',
        defaultPrice: '0.00',
        catalogPrice: '0.00'
      }
    ]);
  };

  const handleCatalogPriceChange = (index, value) => {
    const newProducts = [...products];
    newProducts[index].catalogPrice = value;
    setProducts(newProducts);
  };

  const handleProductSelect = (index, productId) => {
    const newProducts = [...products];
    const oldProductId = newProducts[index].productId;

    if (oldProductId) {
      const newSelected = new Set(selectedProducts);
      newSelected.delete(oldProductId);
      setSelectedProducts(newSelected);
    }

    if (productId) {
      const selectedProduct = productsList.find(
        (p) => p.id === parseInt(productId)
      );
      if (selectedProduct) {
        setSelectedProducts(new Set([...selectedProducts, selectedProduct.id]));
        newProducts[index] = {
          ...newProducts[index],
          productId: selectedProduct.id,
          name: selectedProduct.name,
          defaultPrice: selectedProduct.basePrice
        };
      }
    } else {
      newProducts[index] = {
        ...newProducts[index],
        productId: null,
        name: '',
        defaultPrice: '0.00'
      };
    }

    setProducts(newProducts);
  };

  const handleRemoveProduct = (index) => {
    const removedProduct = products[index];
    if (removedProduct.productId) {
      const newSelected = new Set(selectedProducts);
      newSelected.delete(removedProduct.productId);
      setSelectedProducts(newSelected);
    }
    setProducts(products.filter((_, idx) => idx !== index));
  };

  return (
    <ProductContainer>
      <Button
        className="mb-4"
        onClick={handleAddProduct}
        color="primary"
        size="sm"
      >
        Adicionar Produto
      </Button>

      <Table responsive striped bordered hover>
        <thead>
          <tr>
            <th className="w-50">Produto</th>
            <th className="w-25">Valor Padrão</th>
            <th className="w-25">Valor no Catálogo</th>
            <th className="text-center">Ações</th>
          </tr>
        </thead>
        <tbody>
          {products.length === 0 ? (
            <tr>
              <td colSpan="4" className="text-center text-muted">
                Nenhum produto adicionado
              </td>
            </tr>
          ) : (
            products.map((product, index) => (
              <tr key={product.id}>
                <td>
                  <Select
                    styles={getFlexSelectCustomStyle({ minHeight: '38px' })}
                    classNamePrefix="react-select"
                    placeholder="Selecione..."
                    defaultValue={[]}
                    closeMenuOnSelect={true}
                    noOptionsMessage={() => 'Nenhuma opção'}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    onChange={
                      control
                        ? (selectedOption) =>
                            handleProductSelect(index, selectedOption.value)
                        : (selectedOption) =>
                            handleProductSelect(index, selectedOption.value)
                    }
                    options={
                      control
                        ? getAvailableProducts().map((product) => ({
                            label: product.name,
                            value: product.id
                          }))
                        : getAvailableProducts().map((product) => ({
                            label: product.name,
                            value: product.id
                          }))
                    }
                  />
                </td>
                <td>
                  <Input type="number" value={product.defaultPrice} readOnly />
                </td>
                <td>
                  <Input
                    type="number"
                    value={product.catalogPrice}
                    onChange={(e) =>
                      handleCatalogPriceChange(index, e.target.value)
                    }
                  />
                </td>
                <td className="text-center">
                  <div className="d-flex justify-content-center gap-2">
                    <Button
                      size="sm"
                      color="info"
                      onClick={() => handleInfoClick(product.productId)}
                    >
                      <FaInfoCircle />
                    </Button>
                    <Button
                      size="sm"
                      color="danger"
                      onClick={() => handleRemoveProduct(index)}
                    >
                      <FaTrash />
                    </Button>
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
      <ProductDetailsModal
        isModalOpen={modal}
        onModalToggle={setModal}
        productId={productIdSelectedModal}
      />
    </ProductContainer>
  );
};
